import { useState, useEffect } from 'react'
import { Users } from 'lucide-react'
import { pisteirosService } from '../services/pisteirosService'
import { useOrganizador } from '../contexts/OrganizadorContext'

export default function PisteiroSelect({ organizadorId, value, onChange, disabled, label = 'Quem Captou' }) {
  const { organizadorAtivo } = useOrganizador()
  const [pisteiros, setPisteiros] = useState([])
  const [loading, setLoading] = useState(false)

  const moduloAtivo = organizadorAtivo?.produtos_premium?.includes('quem_vendeu_trouxe')

  useEffect(() => {
    if (!organizadorId || !moduloAtivo) return
    setLoading(true)
    pisteirosService.listar(organizadorId)
      .then(res => {
        const lista = res.data || res
        setPisteiros(Array.isArray(lista) ? lista.filter(p => p.ativo !== false) : [])
      })
      .catch(() => setPisteiros([]))
      .finally(() => setLoading(false))
  }, [organizadorId, moduloAtivo])

  if (!moduloAtivo || pisteiros.length === 0) return null

  return (
    <div>
      <label className="flex items-center gap-2 text-sm font-medium text-gray-700 mb-2">
        <Users size={16} className="text-purple-500" />
        {label}
      </label>
      <select
        value={value || ''}
        onChange={(e) => onChange(e.target.value || null)}
        disabled={disabled || loading}
        className={`w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-lg ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
      >
        <option value="">Nenhum</option>
        {pisteiros.map(p => (
          <option key={p.id} value={p.id}>{p.nome}</option>
        ))}
      </select>
    </div>
  )
}
